// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { DataGrid } from "@mui/x-data-grid";
// import { Box, Button, Typography, Grid } from "@mui/material";
// import AddIcon from "@mui/icons-material/Add";

// import FilterBtn from "../../../../Assets/Icons/btn-filters.png";
// import FilterBtnUp from "../../../../Assets/Icons/btn-filters-up.png";
// import AddUserIcon from "../../../../Assets/Icons/add-user-icon.png";
// import { useNotification } from "../../../../Hooks/useNotification";
// import { useApiErrorHandler } from "../../../../Hooks/useApiErrorHandler";
// import httpclient from "../../../../Utils";
// import { createFilterHandler } from "../../../../Utils/FilterUtils";
// import CustomLoadingOverlay from "../../../../Components/CustomLoadingOverlay";
// import useTokenRefresh from "../../../../Hooks/useTokenRefresh";
// import { buildApiQuery } from "../../../../Utils/apiQueryBuilder";

// import { getColumns } from "./columns";
// import Filter from "./Filter";
// import ConfirmationModal from "./ConfirmationModal";

// const INITIAL_FILTER_STATE = {
//   depoName: "",
// };

// const fieldMappings = {
//   depoName: ["depo", "$contains"],
// };

// const valueTransformers = {};

// export default function DepotTable() {
//   const navigate = useNavigate();

//   const [depots, setDepots] = useState([]);
//   const [selectedDepot, setSelectedDepot] = useState(null);
//   const [filterOpen, setFilterOpen] = useState(false);
//   const [filterData, setFilterData] = useState(INITIAL_FILTER_STATE);
//   const [submittedData, setSubmittedData] = useState({});
//   const [openDeleteDepot, setOpenDeleteDepot] = useState(false);

//   const [loading, setLoading] = useState(false);
//   const [actionLoading, setActionLoading] = useState(false);
//   const [paginationModel, setPaginationModel] = useState({
//     page: 0,
//     pageSize: 20,
//   });
//   const [rowCount, setRowCount] = useState(0);
//   const [sortModel, setSortModel] = useState([]);
//   const [refreshList, setRefreshList] = useState(false);

//   const showNotification = useNotification();
//   const handleApiError = useApiErrorHandler();
//   const { getTokenRefreshed: refresh } = useTokenRefresh();

//   const fetchDepots = async (
//     page = 1,
//     pageSize = 20,
//     filters = submittedData,
//     sortInfo = sortModel
//   ) => {
//     setLoading(true);

//     const endpoint = `delivery/depo`;

//     const apiUrl = buildApiQuery(endpoint, {
//       page: paginationModel.page + 1,
//       pageSize: paginationModel.pageSize,
//       filters: submittedData,
//       sortModel,
//       fieldMappings,
//       valueTransformers,
//     });

//     try {
//       const res = await httpclient.get(apiUrl);
//       const { data } = res;

//       if (data.status === 200) {
//         setDepots(data.data);
//         setRowCount(data.meta?.total || data.count || 0);
//         setRefreshList(false);
//       } else {
//         showNotification("error", data.message);
//       }
//     } catch (error) {
//       if (error.response?.status === 401) {
//         refresh();
//       } else {
//         handleApiError(error);
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchDepots(
//       paginationModel.page + 1,
//       paginationModel.pageSize,
//       submittedData,
//       sortModel
//     );
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [
//     refreshList,
//     paginationModel.page,
//     paginationModel.pageSize,
//     sortModel,
//     submittedData,
//   ]);

//   const handleChangeFilter = (field) => (event, value) => {
//     setFilterData((prev) => ({
//       ...prev,
//       [field]: value || (event && event.target.value) || "",
//     }));
//   };

//   const handleFilter = createFilterHandler({
//     setLoading,
//     setSubmittedData,
//     setResults: setDepots,
//     showNotification,
//     handleApiError,
//     httpClient: httpclient,
//     endpoint: `delivery/depo`,
//     fieldMappings,
//     valueTransformers,
//     refresh,
//   });

//   const onFilterClick = () => {
//     setPaginationModel((prev) => ({ ...prev, page: 0 }));
//     handleFilter(filterData);
//   };

//   const handleRemove = (field) => {
//     const newFilterData = { ...filterData };
//     const newSubmittedData = { ...submittedData };

//     newFilterData[field] = "";
//     delete newSubmittedData[field];

//     setFilterData(newFilterData);
//     setSubmittedData(newSubmittedData);
//     setPaginationModel((prev) => ({ ...prev, page: 0 }));

//     handleFilter(newFilterData);
//   };

//   const handleClearFilters = () => {
//     setFilterData(INITIAL_FILTER_STATE);
//     setSubmittedData({});
//     setPaginationModel((prev) => ({ ...prev, page: 0 }));
//   };

//   const handleAddDepot = () => {
//     navigate("/delivery/depot/add");
//   };

//   const handleSortModelChange = (newSortModel) => {
//     setSortModel(newSortModel);
//     setPaginationModel((prev) => ({ ...prev, page: 0 }));
//   };

//   const handleDeleteDepot = async () => {
//     setActionLoading(true);
//     const API_URL = `delivery/depo/delete/${selectedDepot.id}`;
//     try {
//       const { data } = await httpclient.post(API_URL);
//       if (data.status === 200) {
//         showNotification("success", data.message);
//         setSelectedDepot(null);
//         setOpenDeleteDepot(false);
//         setRefreshList(true);
//       } else {
//         showNotification("info", data.message);
//       }
//     } catch (error) {
//       if (error.response?.status === 404) {
//         showNotification("error", "Depot not found");
//         setTimeout(() => {
//           setRefreshList(true);
//         }, 1000);
//       } else {
//         handleApiError(error);
//       }
//     } finally {
//       setActionLoading(false);
//     }
//   };

//   const columns = getColumns(setOpenDeleteDepot, setSelectedDepot);

//   const deleteDepotMessage = (
//     <>
//       Are you sure you want to delete depot:{" "}
//       <strong>{selectedDepot?.depo}</strong>?
//     </>
//   );

//   return (
//     <Box sx={{ width: "100%", padding: 2 }}>
//       <Box
//         sx={{
//           position: "relative",
//           width: "100%",
//           backgroundColor: "#fff",
//           padding: "24px 16px",
//           borderRadius: "8px",
//         }}
//       >
//         <Grid container spacing={2} alignItems="center">
//           <Grid item xs={12} md={6}>
//             <Typography variant="h6" sx={{ fontWeight: 600 }}>
//               Depots
//             </Typography>
//           </Grid>
//           <Grid
//             item
//             xs={12}
//             md={6}
//             display="flex"
//             alignItems="center"
//             justifyContent="flex-end"
//             gap={2}
//             mb={2}
//           >
//             <Button
//               variant="contained"
//               sx={{
//                 borderRadius: "4px",
//                 backgroundColor: "#7152F3",
//                 "&:hover": {
//                   backgroundColor: "#5c34fa",
//                 },
//               }}
//               startIcon={<AddIcon sx={{ marginRight: 0 }} />}
//               onClick={handleAddDepot}
//             >
//               <Typography
//                 variant="body2"
//                 sx={{
//                   fontSize: "14px",
//                   fontWeight: 500,
//                   textTransform: "none",
//                 }}
//               >
//                 Add New Depot
//               </Typography>
//             </Button>
//             {/* <img
//               src={filterOpen ? FilterBtnUp : FilterBtn}
//               alt="Filter"
//               style={{ cursor: "pointer" }}
//               onClick={() => setFilterOpen(!filterOpen)}
//             /> */}
//           </Grid>
//           {/* <Filter
//             filterOpen={filterOpen}
//             filterData={filterData}
//             handleChangeFilter={handleChangeFilter}
//             handleFilter={onFilterClick}
//             handleClearFilters={handleClearFilters}
//             handleRemove={handleRemove}
//             submittedData={submittedData}
//           /> */}
//         </Grid>

//         <DataGrid
//           rows={depots || []}
//           columns={columns}
//           autoHeight
//           disableRowSelectionOnClick
//           initialState={{
//             pagination: { paginationModel: { pageSize: 20 } },
//           }}
//           loading={loading}
//           slots={{
//             loadingOverlay: CustomLoadingOverlay,
//           }}
//           sx={{
//             "& .MuiDataGrid-cell": {
//               fontSize: "14px",
//               fontWeight: 500,
//               color: "#48505E",
//             },
//           }}
//           paginationMode="server"
//           sortingMode="server"
//           onSortModelChange={handleSortModelChange}
//           sortModel={sortModel}
//           rowCount={rowCount}
//           paginationModel={paginationModel}
//           onPaginationModelChange={setPaginationModel}
//           pageSizeOptions={[20, 50, 100]}
//         />

//         {openDeleteDepot && (
//           <ConfirmationModal
//             open={openDeleteDepot}
//             handleClose={() => setOpenDeleteDepot(false)}
//             title={"Delete Depot"}
//             message={deleteDepotMessage}
//             selectedDepot={selectedDepot}
//             onConfirm={handleDeleteDepot}
//             actionLoadingText="Deleting..."
//             ActionBtnText="Delete"
//             loading={actionLoading}
//           />
//         )}
//       </Box>
//     </Box>
//   );
// }
// ********************************************************************************************
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Button, Typography, Grid } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import FilterBtn from "../../../../Assets/Icons/btn-filters.png";
import FilterBtnUp from "../../../../Assets/Icons/btn-filters-up.png";
import AddUserIcon from "../../../../Assets/Icons/add-user-icon.png";
import { useNotification } from "../../../../Hooks/useNotification";
import { useApiErrorHandler } from "../../../../Hooks/useApiErrorHandler";
import httpclient from "../../../../Utils";
import { createFilterHandler } from "../../../../Utils/FilterUtils";
import CustomLoadingOverlay from "../../../../Components/CustomLoadingOverlay";
import useTokenRefresh from "../../../../Hooks/useTokenRefresh";
import { buildApiQuery } from "../../../../Utils/apiQueryBuilder";

import { getColumns } from "./columns";
import Filter from "./Filter";
import ConfirmationModal from "./ConfirmationModal";

const INITIAL_FILTER_STATE = {
  depoName: "",
};

const fieldMappings = {
  depoName: ["depo", "$contains"],
};

const valueTransformers = {};

export default function DepotTable() {
  const navigate = useNavigate();

  const [depots, setDepots] = useState([]);
  const [selectedDepot, setSelectedDepot] = useState(null);
  const [filterOpen, setFilterOpen] = useState(false);
  const [filterData, setFilterData] = useState(INITIAL_FILTER_STATE);
  const [submittedData, setSubmittedData] = useState({});
  const [openDeleteDepot, setOpenDeleteDepot] = useState(false);

  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 20,
  });
  const [rowCount, setRowCount] = useState(0);
  const [sortModel, setSortModel] = useState([]);
  const [refreshList, setRefreshList] = useState(false);
  const [allowAdd, setAllowAdd] = useState(1);

  const showNotification = useNotification();
  const handleApiError = useApiErrorHandler();
  const { getTokenRefreshed: refresh } = useTokenRefresh();

  const fetchDepots = async (
    page = 1,
    pageSize = 20,
    filters = submittedData,
    sortInfo = sortModel
  ) => {
    setLoading(true);

    const endpoint = `delivery/depo`;

    const apiUrl = buildApiQuery(endpoint, {
      page: paginationModel.page + 1,
      pageSize: paginationModel.pageSize,
      filters: submittedData,
      sortModel,
      fieldMappings,
      valueTransformers,
    });

    try {
      const res = await httpclient.get(apiUrl);
      const { data } = res;

      if (data.status === 200) {
        setDepots(data.data);
        setRowCount(data.meta?.total || data.count || 0);
        if (data.allow_add !== undefined) {
          setAllowAdd(data.allow_add);
        }
        setRefreshList(false);
      } else {
        showNotification("error", data.message);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        refresh();
      } else {
        handleApiError(error);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDepots(
      paginationModel.page + 1,
      paginationModel.pageSize,
      submittedData,
      sortModel
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    refreshList,
    paginationModel.page,
    paginationModel.pageSize,
    sortModel,
    submittedData,
  ]);

  const handleChangeFilter = (field) => (event, value) => {
    setFilterData((prev) => ({
      ...prev,
      [field]: value || (event && event.target.value) || "",
    }));
  };

  const handleFilter = createFilterHandler({
    setLoading,
    setSubmittedData,
    setResults: setDepots,
    showNotification,
    handleApiError,
    httpClient: httpclient,
    endpoint: `delivery/depo`,
    fieldMappings,
    valueTransformers,
    refresh,
  });

  const onFilterClick = () => {
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
    handleFilter(filterData);
  };

  const handleRemove = (field) => {
    const newFilterData = { ...filterData };
    const newSubmittedData = { ...submittedData };

    newFilterData[field] = "";
    delete newSubmittedData[field];

    setFilterData(newFilterData);
    setSubmittedData(newSubmittedData);
    setPaginationModel((prev) => ({ ...prev, page: 0 }));

    handleFilter(newFilterData);
  };

  const handleClearFilters = () => {
    setFilterData(INITIAL_FILTER_STATE);
    setSubmittedData({});
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  };

  const handleAddDepot = () => {
    navigate("/delivery/depot/add");
  };

  const handleSortModelChange = (newSortModel) => {
    setSortModel(newSortModel);
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  };

  const handleDeleteDepot = async () => {
    setActionLoading(true);
    const API_URL = `delivery/depo/delete/${selectedDepot.id}`;
    try {
      const { data } = await httpclient.post(API_URL);
      if (data.status === 200) {
        showNotification("success", data.message);
        setSelectedDepot(null);
        setOpenDeleteDepot(false);
        setRefreshList(true);
      } else {
        showNotification("info", data.message);
      }
    } catch (error) {
      if (error.response?.status === 404) {
        showNotification("error", "Depot not found");
        setTimeout(() => {
          setRefreshList(true);
        }, 1000);
      } else {
        handleApiError(error);
      }
    } finally {
      setActionLoading(false);
    }
  };

  // Pass setRefreshList to columns for edit functionality
  const columns = getColumns(setOpenDeleteDepot, setSelectedDepot, setRefreshList);

  const deleteDepotMessage = (
    <>
      Are you sure you want to delete depot:{" "}
      <strong>{selectedDepot?.depo}</strong>?
    </>
  );

  return (
    <Box sx={{ width: "100%", padding: 2 }}>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          backgroundColor: "#fff",
          padding: "24px 16px",
          borderRadius: "8px",
        }}
      >
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Depots
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            display="flex"
            alignItems="center"
            justifyContent="flex-end"
            gap={2}
            mb={2}
          >
            {allowAdd === 1 && (

            
            <Button
              variant="contained"
              sx={{
                borderRadius: "4px",
                backgroundColor: "#7152F3",
                "&:hover": {
                  backgroundColor: "#5c34fa",
                },
              }}
              startIcon={<AddIcon sx={{ marginRight: 0 }} />}
              onClick={handleAddDepot}
            >
              <Typography
                variant="body2"
                sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  textTransform: "none",
                }}
              >
                Add New Depot
              </Typography>
            </Button>
            )}
          </Grid>
        </Grid>

        <DataGrid
          rows={depots || []}
          columns={columns}
          autoHeight
          disableRowSelectionOnClick
          initialState={{
            pagination: { paginationModel: { pageSize: 20 } },
          }}
          loading={loading}
          slots={{
            loadingOverlay: CustomLoadingOverlay,
          }}
          sx={{
            "& .MuiDataGrid-cell": {
              fontSize: "14px",
              fontWeight: 500,
              color: "#48505E",
            },
          }}
          paginationMode="server"
          sortingMode="server"
          onSortModelChange={handleSortModelChange}
          sortModel={sortModel}
          rowCount={rowCount}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          pageSizeOptions={[20, 50, 100]}
        />

        {openDeleteDepot && (
          <ConfirmationModal
            open={openDeleteDepot}
            handleClose={() => setOpenDeleteDepot(false)}
            title={"Delete Depot"}
            message={deleteDepotMessage}
            selectedDepot={selectedDepot}
            onConfirm={handleDeleteDepot}
            actionLoadingText="Deleting..."
            ActionBtnText="Delete"
            loading={actionLoading}
          />
        )}
      </Box>
    </Box>
  );
}